import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { FinancialDocumentRowFormSchemaValues } from 'src/features/financialDocumentRows/utils/formSchema';
import { FinancialDocumentRow } from 'src/features/financialDocumentRows/utils/types';

const RESOURCE = '/financial-documents/financial-document-row/:rowId/';

type MutationFnType = typeof mutationFn;

interface DTO extends FinancialDocumentRowFormSchemaValues {
    rowId: string;
    financial_document: string;
}
const mutationFn = ({ rowId, ...data }: DTO): Promise<FinancialDocumentRow> => {
    return axios.put(formatResourcePath(RESOURCE, { rowId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateFinancialDocumentRow };
